var _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16675 10.9252C3.16675 9.23335 3.16675 8.38741 3.64594 7.82635C3.71398 7.74668 3.78818 7.67248 3.86785 7.60443C4.42891 7.12524 5.27486 7.12524 6.96675 7.12524H12.0334C13.7253 7.12524 14.5713 7.12524 15.1323 7.60443C15.212 7.67248 15.2862 7.74668 15.3542 7.82635C15.8334 8.38741 15.8334 9.23335 15.8334 10.9252V10.9252C15.8334 13.4631 15.8334 14.732 15.1146 15.5736C15.0126 15.6931 14.9013 15.8044 14.7818 15.9065C13.9402 16.6252 12.6713 16.6252 10.1334 16.6252H8.86675C6.32891 16.6252 5.05999 16.6252 4.2184 15.9065C4.0989 15.8044 3.9876 15.6931 3.88553 15.5736C3.16675 14.732 3.16675 13.4631 3.16675 10.9252V10.9252Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 7.12506L13.1239 6.63375C13.3289 4.99375 12.5909 3.37845 11.217 2.45979V2.45979C9.58107 1.36598 7.41579 1.50079 5.9282 2.78909L5.28035 3.35014",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.50008,
    cy: 11.8751,
    rx: 1.58333,
    ry: 1.58333,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.651294bcc69a04cbb6cbe15c0fb5e876.svg";
export { ForwardRef as ReactComponent };